module.exports = __webpack_public_path__ + "static/img/11.4ebe2f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/zh/11.png
// module id = idHI
// module chunks = 0